import { AppState } from '../app/state';
import { connect, Dispatch } from 'react-redux';
import { LoginAction, SwitchToUsernameLoginAction } from './actions';
import { LoginPage, LoginProps, LoginActionProps } from './component';
import { LoginType } from 'types/login-type';
import { ResetPasswordAction } from 'pages/user-management/actions';
import { Action } from 'helpers/action-helpers';

function mapStateToProps({ login, settings, userManagement }: AppState): LoginProps {
  return {
    loginType: login.loginType,
    username: login.username,
    loginErrorMessage: login.loginErrorMessage,
    isProcessing: login.isProcessing,
    isProcessingPasswordReset: userManagement.isProcessing,
    hasEnterpriseLogin: settings.tenant.hasEnterpriseLogin,
    passwordResetSuccess: userManagement.passwordResetSuccess,
    passwordResetErrorMessage: userManagement.passwordResetErrorMessage
  };
}

function mapDisptachToProps(dispatch: Dispatch<Action>): LoginActionProps {
  return {
    login: (loginType: LoginType, usernameOrBarcode: string, passwordOrPin: string) =>
      dispatch(new LoginAction(loginType, usernameOrBarcode, passwordOrPin)),
    cancel: () =>
      dispatch(new SwitchToUsernameLoginAction('')),
    resetPassword: (userEmail: string) =>
      dispatch(new ResetPasswordAction(userEmail))
  };
}

export default connect(mapStateToProps, mapDisptachToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/login/index.ts